module.exports = "<div class=\"pos-f-t usc-header no-print\">\n    <nav class=\"navbar navbar-expand-lg navbar-inverse\">\n        <div class=\"row header-main views\">\n            <ul class=\"nav navbar-nav pull-xs-left\">\n            </ul>\n        </div>\n    </nav>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-doc-nav/usc-doc-nav.component.html
// module id = ../../../../../src/app/components/usc-store/usc-doc-nav/usc-doc-nav.component.html
// module chunks = main